export default "__VITE_ASSET__0adb70f4__$_?used__"